import React from 'react'
import css from './style.css'

const PaginationButton = (props) => (
  <button onClick={props.onClick} className={css.paginationButton}>
    {props.children}
  </button>
)

export default PaginationButton



// WEBPACK FOOTER //
// ./src/components/diamond-modal/pagination-button.js